import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#747474',
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

interface Props {
  data: Array<any>
}

const Corretores: React.FC<Props> = ({ data }) => {
  const classes = useStyles();

  return (
    <TableContainer component={Paper} style={{ marginTop: 20, marginBottom: 20 }}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow>
            {/* @ts-ignore */}
            <StyledTableCell>Nome</StyledTableCell>
            {/* @ts-ignore */}
            <StyledTableCell align="right">Sigla</StyledTableCell>
            {/* @ts-ignore */}
            <StyledTableCell align="right">Online&nbsp;</StyledTableCell>
            {/* @ts-ignore */}
            <StyledTableCell align="right">PDV&nbsp;</StyledTableCell>
            {/* @ts-ignore */}
            <StyledTableCell align="right">Telefone&nbsp;</StyledTableCell>
            {/* @ts-ignore */}
            <StyledTableCell align="right">Total&nbsp;</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((row) => (
            <>
              {/* @ts-ignore */}
              <StyledTableRow key={row.name}>
                {/* @ts-ignore */}
                <StyledTableCell component="th" scope="row">
                  {row.nome}
                </StyledTableCell>
                {/* @ts-ignore */}
                <StyledTableCell align="right">{row.sigla}</StyledTableCell>
                {/* @ts-ignore */}
                <StyledTableCell align="right">{row.totalOnline}</StyledTableCell>
                {/* @ts-ignore */}
                <StyledTableCell align="right">{row.totalPdv}</StyledTableCell>
                {/* @ts-ignore */}
                <StyledTableCell align="right">{row.totalTelefone}</StyledTableCell>
                {/* @ts-ignore */}
                <StyledTableCell align="right">{row.total}</StyledTableCell>
              </StyledTableRow>
            </>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Corretores;
